<template>
    <content-dashboard :hide="true">
        <v-card>
            <v-card-title class="subtitle-1">Filtros</v-card-title>
            <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
                <v-row>
                    <v-col cols="12" md="3" sm="6">
                        <v-select
                            :items="optionsAno"
                            outlined
                            dense
                            v-model="filtro.ano_notificacao"
                            label="Ano de Referência"
                        ></v-select>
                    </v-col>

                    <v-col cols="12" md="3" sm="6">
                        <v-select
                            :items="optionsNotificacoes"
                            outlined
                            dense
                            v-model="filtro.tipo_notificacao"
                            label="Tipo de Notificação"
                        ></v-select>
                    </v-col>

                </v-row>
            </v-form>
            </v-card-text>
            <v-card-actions class="justify-center">
                <v-btn color="primary" @click="load(filtro)">Pesquisar</v-btn>
                <v-btn color="primary" outlined class="ml-5" @click="reset">Limpar</v-btn>
            </v-card-actions>
        </v-card>

        <v-divider class="my-2 mb-10 mt-10"></v-divider>

        <v-card>
            <v-card-title class="subtitle-1">Autos Status</v-card-title>
            <v-card-text>
                <v-simple-table>
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="text-left">Mês</th>
                                <th class="text-left">Quantidade de Autos</th>
                                <th class="text-left">Valor</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in items" :key="item.name">
                                <td>{{ item.mes_refencia_relatorio   || "-" }}</td>
                                <td>{{ item.quantidade_notificacoes  || "-" }}</td>
                                <td>{{ item.valor_monetario_infracao || "-" }}</td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card-text>
        </v-card>
    </content-dashboard>
</template>

<script>
import urlApi from "@/routes/urlApi";
import { showError } from "@/global";
import queryString from "querystring";

export default {
    name: "Notificacoes",
    data() {
        return {
            loading: false,
            valid: true,
            rules: [v => !!v || "Este campo é Obrigatório"],
            filtro: {},
            items: [],

            optionsNotificacoes: [
                {text: "Notificação de Autuação",   value: 1},
                {text: "Notificação de Penalidade", value: 2},
            ],

            optionsAno: [
                {text: "Período Anual 2020", value: 2020},
                {text: "Período Anual 2021", value: 2021},
            ],
            
            headers: [
                {
                    text: "Mês",
                    value: "mes_refencia_relatorio"
                },
                {
                    text: "Quantidade de Autos",
                    value: "quantidade_notificacoes"
                },
                {
                    text: "Valor",
                    value: "valor_monetario_infracao"
                },
            ],
        };
    },

    created() {
        this.load();
    },

    methods: {
        load(filtro) {
            this.$store.commit("overlay/toggle", true);
            
            var filter = {};

            if (filtro) {
                if (!this.$refs.form.validate()) return;
                var filter = queryString.stringify(filtro);
            }
            
            const url = `${urlApi}/relatorio/notificacoes?${filter}`;

            this.$http.get(url).then(res => {
                const response = res.data;

                this.items = response.data;

                this.$store.commit("overlay/toggle", false);
            }).catch((error) => {
                let erro = error.body.data;
        
                showError(`Ops, ${erro}`);

                this.$store.commit("overlay/toggle", false);
            });
        },

        reset() {
            this.filtro = {};
        },
    }
};
</script>